import { render, staticRenderFns } from "./ADRsLogo.vue?vue&type=template&id=12b42301&scoped=true&"
import script from "./ADRsLogo.vue?vue&type=script&lang=js&"
export * from "./ADRsLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b42301",
  null
  
)

export default component.exports